const getZoomDefaults = (zoomOptions) => ({
  showDataShadow: false,
  filterMode: 'none',
  xAxisIndex: [0, 1],
  showDetail: false,
  ...zoomOptions,
});

export const getDataZoomOptions = (zoomOptions = {}) => [{
  ...getZoomDefaults(zoomOptions),
  type: 'slider',
}, {
  ...getZoomDefaults(zoomOptions),
  type: 'inside',
}];
